import { Dialog, GridHookForm } from 'vnetwork-ui'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useModal } from '@/contexts/modal'
import { useState } from 'react'
import useUploadFile from '@/hooks/useUploadFile'
import { STORGE_PREFIXS } from '@/modules/Contract/modules/Process/constants'
import { renderFileItem } from '@/utils/function'
import { Attachment } from '@/modules/Upload/types'

interface RejectNegotiationProps {
    onSubmit: (data: {
        reason: string
        notes?: string
        attachments?: Attachment[]
    }) => Promise<void>
}

interface RejectFormData {
    reason: string
    notes?: string
    attachments: File[]
}

const RejectNegotiation: React.FC<RejectNegotiationProps> = ({ onSubmit }) => {
    const { t } = useTranslation()
    const { closeModal } = useModal()
    const [isSubmitting, setIsSubmitting] = useState(false)

    const { uploadAsync } = useUploadFile({
        prefix: STORGE_PREFIXS.CONTRACT_NEGOTIATION,
    })

    const formControl = useForm<RejectFormData>({
        defaultValues: {
            reason: '',
            notes: '',
            attachments: [],
        },
    })

    const handleSubmit = async (values: RejectFormData) => {
        setIsSubmitting(true)
        try {
            let attachments: Attachment[] = []
            if (values.attachments && values.attachments.length > 0) {
                const attachmentUploadeds = await uploadAsync(
                    values.attachments
                )
                attachments = attachmentUploadeds
                    ?.filter((attachment) => attachment.status === 'fulfilled')
                    .map((attachment) => attachment.value) as Attachment[]
            }

            await onSubmit({
                reason: values.reason,
                notes: values.notes,
                attachments,
            })
            closeModal()
        } catch (error) {
            console.error('Error rejecting negotiation:', error)
        } finally {
            setIsSubmitting(false)
        }
    }

    return (
        <Dialog open onClose={closeModal} title={t('reject-negotiation')}>
            <GridHookForm
                formControl={formControl}
                onSubmit={handleSubmit}
                actions={[
                    {
                        title: t('cancel'),
                        type: 'button',
                        variant: 'outlined',
                        handler: closeModal,
                    },
                    {
                        title: t('reject-negotiation'),
                        type: 'submit',
                        variant: 'contained',
                        loading: isSubmitting,
                        disabled: isSubmitting,
                    },
                ]}
                data={[
                    {
                        formItemProps: {
                            name: 'reason',
                            type: 'textarea',
                            label: t('rejection-reason'),
                            placeholder: t('enter-rejection-reason'),
                        },
                        className: 'col-span-full',
                    },
                    {
                        formItemProps: {
                            name: 'notes',
                            type: 'textarea',
                            label: t('rejection-notes'),
                            placeholder: t('enter-rejection-notes'),
                        },
                        className: 'col-span-full',
                    },
                    {
                        formItemProps: {
                            name: 'attachments',
                            type: 'files',
                            multiple: true,
                            label: t('attachments'),
                            renderFileItem: (file: File) => {
                                return renderFileItem(file, () => {})
                            },
                        },
                        className: 'col-span-full',
                    },
                ]}
            />
        </Dialog>
    )
}

export default RejectNegotiation
